var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View, Image } from 'react-native';
import { getBlogCardWidgetStyles } from './BlogCardWidgetStyles';
import { Card, getTestId, isValidObject, Typography, useBreakpoint } from '@airtel/air-design-system';
export var BlogCardWidgetComponent = props => {
  var imageUrl = props.imageUrl,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'BlogCardWidget' : _props$testID,
    title = props.title,
    description = props.description,
    _props$descriptionNum = props.descriptionNumOfLines,
    descriptionNumOfLines = _props$descriptionNum === void 0 ? 4 : _props$descriptionNum,
    style = props.style,
    _props$titleAccessibi = props.titleAccessibilityProps,
    titleAccessibilityProps = _props$titleAccessibi === void 0 ? {} : _props$titleAccessibi,
    _props$descriptionAcc = props.descriptionAccessibilityProps,
    descriptionAccessibilityProps = _props$descriptionAcc === void 0 ? {} : _props$descriptionAcc,
    restProps = __rest(props, ["imageUrl", "testID", "title", "description", "descriptionNumOfLines", "style", "titleAccessibilityProps", "descriptionAccessibilityProps"]);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var blogCardWidgetStyles = getBlogCardWidgetStyles(isLargeScreen, props);
  if (!isValidObject(imageUrl) || !title || !description) return null;
  return _jsxs(Card, Object.assign({}, getTestId(testID), {
    noPadding: true,
    style: [blogCardWidgetStyles.card, style]
  }, restProps, {
    children: [isValidObject(imageUrl) && _jsx(Image, {
      style: [blogCardWidgetStyles.blogImage],
      source: {
        uri: isLargeScreen ? imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.desktop : imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.mobile
      }
    }), (!!title || !!description) && _jsxs(View, Object.assign({
      style: blogCardWidgetStyles.contentContainer
    }, {
      children: [!!title && _jsx(Typography, Object.assign({
        text: title,
        type: "body-single-line-md-bold"
      }, titleAccessibilityProps)), !!description && _jsx(Typography, Object.assign({
        text: description,
        type: "body-para-md",
        numberOfLines: descriptionNumOfLines,
        style: {
          marginTop: 4
        }
      }, descriptionAccessibilityProps))]
    }))]
  }));
};
BlogCardWidgetComponent.genericRendererKey = 'AirBlogCardWidget';